import React, { useContext } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { debug, sortObjectsByAlphabet } from "../../utils";
import { useHistory } from "react-router-dom";
import * as urlService from "../../view/urlService";
import { TableContext } from "../../index";

function ScheduleDeviceTypeField({ deviceTypes = [], selectType, selectedType, setMsbId, setDeviceId }) {
    const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;
    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (selectedOption) => {
        const deviceTypeId = selectedOption?.value ?? -1;
        setDeviceId(-1);
        setMsbId(-1);
        selectType(deviceTypeId);

        if (deviceTypeId === -1) {
            setConfig({ ...config, deviceId: -1 });
            const aryFilters = ['device', 'deviceType', 'msb'];
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilters(aryFilters)
            });
            return;
        }

        if (deviceTypes) {
            const deviceType = deviceTypes.find(type => type.id === Number(deviceTypeId));

            if (!deviceType) {
                setConfig({ ...config, deviceId: -1 });
                return;
            }

            history.push({
                pathname: history.pathname,
                search: urlService.replaceFilters('deviceType', deviceType.name)
            });
        }
    };

    const deviceTypeCopy = sortObjectsByAlphabet(deviceTypes, 'name');

    const options = deviceTypeCopy.map(device => ({
        value: device.id,
        label: device.name
    }));
    const selectedOption = options.find((option) => String(option.value) === String(selectedType)) || null;

    return (
        <div className="modal-v2-schedule-field-group">
            <label htmlFor="schedule-device-type">Device Type <span className="modal-v2-required-mark">*</span></label>
            <Select
                inputId="schedule-device-type"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={selectedOption}
                onChange={onChange}
                options={options}
                isSearchable
                menuPlacement="auto"
                menuPosition="fixed"
                menuPortalTarget={menuPortalTarget}
                maxMenuHeight={240}
                minMenuHeight={240}
                placeholder="Select device type"
                noOptionsMessage={() => "No device types available"}
            />
        </div>
    );
}

function mapStateToProps(state) {
    debug("ScheduleDeviceTypeField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        deviceTypes: addDeviceModal.deviceTypes
    };
}

export default connect(mapStateToProps)(ScheduleDeviceTypeField);
